module.exports = "/images/square-x-twitter.svg?6b50ed3cf08d12625b04951b053f9bd9";